const config = {
  api: {
    host: process.env.REACT_APP_BACKEND_URL,
    timeout: 20000,
  },
};

export const Method = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
};
const API_HOST = config.api.host;

export const ApiEndpoint = {
  // GET_DOCTORS: API_HOST + "user/doctor",
  GET_DOCTORS: API_HOST + "user/doctor/caching",
  GET_PHARMACIES: API_HOST + "user/pharmacy",
  GET_FAVOURITE_DOCTORS_FOR_PATIENT: API_HOST + "favourite/patient/get-doctors",
  GET_FAVOURITE_PHARMACIES_FOR_PATIENT:
    API_HOST + "favourite/patient/get-pharmacies",
  ADD_TO_FAVOURITE_PHARMACIES: API_HOST + "favourite/patient/add-pharmacy/",
  REMOVE_FROM_FAVOURITE_PHARMACIES:
    API_HOST + "favourite/patient/remove-pharmacy/",
  ADD_TO_FAVOURITE_DOCTORS: API_HOST + "favourite/patient/add-doctor/",
  REMOVE_FROM_FAVOURITE_DOCTORS: API_HOST + "favourite/patient/remove-doctor/",
  GET_ORDER_BY_ID: API_HOST + "pharmacy-order/",
  GET_PHARMACY_BY_ID: API_HOST + "user/pharmacy/",
  GET_DOCTOR_BY_ID: API_HOST + "user/doctor/",
  GET_AVAILABILITY_BY_DATE: API_HOST + "availability/patient/get/",
  GET_APPOINTMENTS: API_HOST + "appointment/patient",
  FORGOT_PASSWORD: API_HOST + "user/forgot-password",
  VERIFY_EMAIL_CODE: API_HOST + "user/verify-email-code",
  UPDATE_PASSWORD: API_HOST + "user/update-password",
  PROFILE_PIC_UPDATE: API_HOST + "user/update-profile-image",
  WRITE_REVIEW: API_HOST + "appointment-review",
  REGISTER_DEVICE_TOKEN: API_HOST+'device-token',
};

export const StatusCode = {
  success: 200,
};

export default { Method, ApiEndpoint, StatusCode };
